<template lang="pug">
section.section-content.section-content--data-usage
    .box#family
        header.box__header.no-border.flex.items-center.justify-between
            .header-meta
                h2.subheading Family Information
            .header-cta

        .box__body.p-4
            template(v-if="load_data_status_profile.status === 'loading' && load_data_status_profile_count.family === 'loading'")
                Loading(show="true")

            template(v-else)
                template(v-if="profile_family && Object.keys(profile_family).length > 0")

                    .box--items.p-4.mb-4.rounded(v-for="(family, index) in profile_family")
                        .flex.flex-wrap.-mx-4
                            .block.px-4(class="w-full lg:w-1/4")
                                .block.mb-4
                                    span.text-light Name
                                    //- h3.monospace {{ family.full_name ? family.full_name : '-' }} ({{ family.family_conection ? family.family_conection : '-' }})
                                    h3.monospace
                                        router-link.link-text(v-if="family.full_name && family.full_name.length > 0" :to="'/search-by-name/'+ encrypt(family.full_name, 'name')" target="_blank")
                                            | {{ family.full_name ? family.full_name : '-' }} ({{ family.family_conection ? family.family_conection : '-' }})
                                        template(v-else) {{ family.full_name ? family.full_name : '-' }} ({{ family.family_conection ? family.family_conection : '-' }})
                                .block.mb-4
                                    span.text-light KTP/NIK
                                    h3.monospace {{ family.nik ? family.nik : '-' }}
                                .block.mb-4
                                    span.text-light NKK
                                    h3.monospace {{ family.family_id ? family.family_id : '-' }}
                                .block.mb-4
                                    span.text-light Phone
                                    h3.monospace {{ (family.phone && family.phone.length>0 ? family.phone.join(', '):'-') }}

                            .block.px-4(class="w-full lg:w-1/4")
                                .block.mb-4
                                    span.text-light Gender
                                    h3.monospace {{ family.gender ? family.gender : '-' }}
                                .block.mb-4
                                    span.text-light DOB
                                    h3.monospace {{ family.birth_date ? family.birth_date : '-' }}
                                .block.mb-4
                                    span.text-light POB
                                    h3.monospace {{ family.birth_place ? family.birth_place : '-' }}
                                //- .block.mb-4
                                    span.text-light Weton
                                    h3.monospace {{ family.weton ? family.weton : '-' }}
                                .block.mb-4
                                    span.text-light Zodiac
                                    h3.monospace {{ family.zodiac ? family.zodiac : '-' }}
                            .block.px-4(class="w-full lg:w-1/4")
                                .block.mb-4
                                    span.text-light Province
                                    h3.monospace {{ family.address_province ? family.address_province : '-' }}
                                .block.mb-4
                                    span.text-light City
                                    h3.monospace {{ family.address_district ? family.address_district : '-' }}
                                .block.mb-4
                                    span.text-light Sub District
                                    h3.monospace {{ family.address_sub_district ? family.address_sub_district : '-' }}
                                .block.mb-4
                                    span.text-light RT/RW
                                    h3.monospace {{ family.address_rt ? family.address_rt : '-' }}/{{ family.address_rw ? family.address_rw : '-' }}
                                .block.mb-4
                                    span.text-light Address
                                    h3.monospace {{ family.address ? family.address : '-' }}
                            .block.px-4(class="w-1/5")
                                .block.mb-4(v-if="family.photo != '-'")
                                    img(:src="family.photo")
                                .block.mb-4(v-else)
                                    img(src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQDL6TQy3sIznqksMdJuEJwG_fthjL0oBiyEPf1_mR2KUmI-zIX&usqp=CAU")
                
                //- template(v-else) Data Not Found
                NoDataAvailable(v-else)

</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { encrypt } from '@/util/crypto';

export default {
    name: 'FamilyProfile',
    components: {
        Loading,
        NoDataAvailable,
    },
    computed: {
        ...mapState([
          'load_data_status_profile',
          'load_data_status_profile_count',
          'profile_family',
        ]),
    },
    methods: {
        encrypt(key, type) {
            return encrypt(key + '&&' + type);
        },
    },
    mounted() {
        // console.log(this.$route.query.show);
    }
}
</script>

<style lang="sass">

</style>
